export const configs = {
    base_url: process.env.REACT_APP_BASE_URL,
    prod_url: process.env.REACT_APP_PROD_URL,
    sf_dealer_id: process.env.REACT_APP_DEALERID,
    sf_wss_id: process.env.REACT_APP_WSSID,
    google_map_auth_key: process.env.REACT_APP_GOOGLE_MAP_KEY,
    my_user_api_id: process.env.REACT_APP_MY_USER_API_KEY,
    pcms_url: process.env.REACT_APP_PCMS_BASE_URL,
};